var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApprove = function SvgApprove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M16.395 5.947a8 8 0 1 1-3.207-3.763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.5 9 8 12l7.5-8.5"
  })));
};
export { SvgApprove as ReactComponent };
export default __webpack_public_path__ + "9b66c89f17a308d99bc61a6726484505.svg";